
export const ACTION_METRIC = {
	/** Component based */
	PROCEED_TO_PAYMENT: 'Proceed to payment',
	BACK_TO_SEARCH: 'Back to search',
	MORE_INFO_MODAL: 'More info modal',
	SEARCH_PRODUCT_FILTER: 'Product filter',
	TRAVEL_INSURANCE_TRIP_START: 'Travel insurance trip start',
	TRAVEL_INSURANCE_TRIP_END: 'Travel insurance trip end',
	TRAVEL_INSURANCE_TRAVELLING_TO: 'Travel insurance travelling to',
	TRAVEL_INSURANCE_TRAVELLER_DOB: 'Travel insurance traveller date of birth',
	SHARE_BUTTON: 'Share Button',
	OPEN_EMAIL_RECEIPT_MODAL: 'Open Email Receipt Modal',
	CLOSE_EMAIL_RECEIPT_MODAL: 'Close Email Receipt Modal',
	PRINT_BOOKING_RECEIPT: 'Print Booking Receipt',
	/** Api based */
	SEARCH_COMPLETED: 'Search Metric: Completed',
	SEARCH_PRODUCT_AVAILABILITY_SUCCESS: 'Search Metric: searchProductAvailabilitySuccess',
};

export const ERROR_METRIC = {
	SEARCH_COMPLETED: 'Search Metric: Search Completed',
	SEARCH_PRODUCT_FAILED_EVENT: 'Search Metric: SearchProductFailedEvent',
	SECONDARY_PRODUCT_ERROR: 'Search Metric: Secondary product error',
	SEARCH_EXCEPTION: 'Search Metric: Exception',
}

export const METRIC_TYPE = {
	TRACKING: 'tracking',
	ERROR: 'error'
}

export const CONTEXT_KEYS = {
	TRAVEL_INSURANCE: 'travel_insurance',
	TRAVEL_EXTRAS: 'travel_extras',
	SEARCH_SERVICE: 'search_service',
	SEARCH_EXTRAS_FILTER: 'search_extras_filter',
	SEARCH_BOX_LOUNGES: 'search_box_lounges',
	SEARCH_BOX: 'search_box',
	TRAVEL_INSURANCE_FORM: 'travel_insurance_form',
	B_TICKET_SHARE_BUTTON: 'b_ticket_share_button',
	MANAGE_BOOKING_SHARE_BUTTON: 'manage_booking_share_button',
};
